import React from 'react'
import styles from './DashboardBox.less'
import { FAIcon } from './FAIcon'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { ah, compose, ReduxWrapper } from 'common-data/datahelpers'
import _ from 'lodash'

export const DashboardBoxStyles = {
  Default: 0,
  Appointment: 1,
  Meeting: 2,
  Request: 3,
  Fleet: 4,
  Rooms: 5,
  Assets: 6,
  Movement: 7,
  StockItem: 8,
  GatePass: 9
}

export const DashboardBoxLayout = {
  xs: 24,
  sm: 24,
  md: 12,
  lg: 6
}

class DashboardBoxPlain extends React.Component {
  static propTypes = buildPropTypes([], {
    boxStyle: pt.number.isRequired,
    icon: pt.string.isRequired,
    itemCount: pt.number.isRequired,
    messageText: pt.string.isRequired,
    linkText: pt.string.isRequired,
    onClick: pt.oneOfType([pt.func, pt.string]),
    hide: pt.bool.isRequired
  })

  static defaultProps = {
    boxStyle: 0,
    icon: 'user',
    itemCount: 0,
    messageText: 'Some Value',
    linkText: 'View Details',
    hide: false
  }

  onClick () {
    const { sendToURL, onClick } = this.props

    if (_.isFunction(onClick)) {
      const ret = onClick()
      if (_.isString(ret)) {
        sendToURL(ret)
      }
    }

    if (_.isString(onClick)) {
      sendToURL(onClick)
    }
  }

  render () {
    const { boxStyle, icon, itemCount, messageText, onClick, linkText, hide, seconditemCount } = this.props

    if (hide) {
      return null
    }

    return (
      <div className={styles.box}>
        <div className={styles[`boxUp${boxStyle}`]}>
          <div className={styles.boxUpIcon}>
            <FAIcon name={icon} />
          </div>
          {seconditemCount
            ? <div className={styles.boxUpData}>
              <div className={styles.boxUpDataNumber2}>Approved:{seconditemCount} Pending:{itemCount}</div>
              <div className={styles.boxUpDataText}>{messageText}</div>
            </div>
            : <div className={styles.boxUpData}>
              <div className={styles.boxUpDataNumber}>{itemCount}</div>
              <div className={styles.boxUpDataText}>{messageText}</div>
            </div>}
        </div>
        <div onClick={this.onClick.bind(this)} className={`${styles[`boxDown${boxStyle}`]} ${onClick ? styles.withCursor : ''}`}>
          {onClick
            ? [
              <div key='bdt' className={styles.boxDownText}>
                {linkText}
              </div>,
              <div key='bda' className={styles.boxDownArrow}>
                <FAIcon name='arrow-right' />
              </div>
            ]
            : null
          }
        </div>
      </div>
    )
  }
}

export const DashboardBox = compose(
  ReduxWrapper(
    [],
    [ah.sendToURL]
  )
)(DashboardBoxPlain)

export default DashboardBox
